<ng-container *transloco="let t">
<form #declarationsForm="ngForm" novalidate id="declarationsForm" name="declarationsForm">
  <div class="row mb-5 rounded border p-4"
    [ngClass]="{'border-danger': occupyProperty.touched && occupyProperty.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.occupyProperty') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" name="occupancyQuestion" required [value]="true" type="radio" id="aYes{{borrower.borrowerId}}"
            [(ngModel)]="borrower.declarations!.occupyProperty" #occupyProperty="ngModel"
            (change)="occupyPropertyChange()" />
          <label style="padding-right: 6px;" class="form-check-label" for="aYes{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" name="occupancyQuestion" required [value]="false" type="radio" id="aNo{{borrower.borrowerId}}"
            [(ngModel)]="borrower.declarations!.occupyProperty" #occupyProperty="ngModel"
            (change)="occupyPropertyChange()" />
          <label style="padding-right: 6px;" class="form-check-label" for="aNo{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
  </div>
  @if (borrower.declarations!.occupyProperty) {
    <div class="row mb-5 rounded border p-4"
      [ngClass]="{'border-danger': havePropertiesOwnership.touched && havePropertiesOwnership.invalid}">
      <div class="col-lg-10 col-md-12">
        <div class="position-relative">
          {{ t('wizard.declarations.havePropertiesOwnership') }}
        </div>
      </div>
      <div class="col-lg-2 col-sm-6">
        <div class="d-flex">
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" name="havePropertiesOwnership" required [value]="true" type="radio"
              id="havePropertiesOwnershipYes{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.havePropertiesOwnership"
              #havePropertiesOwnership="ngModel" (change)="havePropertiesOwnershipChange()" />
            <label style="padding-right: 6px;" class="form-check-label" for="havePropertiesOwnershipYes{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
          </div>
          <div class="form-check form-check-custom form-check-solid ms-8">
            <input class="form-check-input" name="havePropertiesOwnership" required [value]="false" type="radio"
              id="havePropertiesOwnershipNo{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.havePropertiesOwnership"
              #havePropertiesOwnership="ngModel" (change)="havePropertiesOwnershipChange()" />
            <label style="padding-right: 6px;" class="form-check-label" for="havePropertiesOwnershipNo{{borrower.borrowerId}}">{{ t('common.no') }}</label>
          </div>
        </div>
      </div>
    </div>
  }
  @if (borrower.declarations!.havePropertiesOwnership && borrower.declarations!.occupyProperty) {
    <div class="row mb-5 rounded border p-4">
      <div class="col-md-8 fw-row ml-2">
        <div class="position-relative">
          {{ t('wizard.declarations.typeOfPropertyQuestion') }}
        </div>
      </div>
      <div class="col-md-4">
        <select name="typeOfProperty" required
          [ngClass]="{'is-invalid' : typeOfProperty && typeOfProperty.touched && typeOfProperty.invalid}"
          [(ngModel)]="borrower.declarations!.typeOfProperty" class="form-select form-select-solid"
          #typeOfProperty="ngModel" data-placeholder="Select One">
          <option></option>
          @for (propertyType of propertyTypes; track propertyType.value) {
            <option [value]="propertyType.value">
              {{propertyType.name}}
            </option>
          }
        </select>
        <div class="invalid-feedback">{{ t('wizard.declarations.typeOfPropertyRequired') }}</div>
      </div>
    </div>
  }
  @if (borrower.declarations!.havePropertiesOwnership && borrower.declarations!.occupyProperty) {
    <div class="row mb-5 rounded border p-4">
      <div class="col-md-8 fw-row">
        <div class="position-relative">
          {{ t('wizard.declarations.heldTitleQuestion') }}
        </div>
      </div>
      <div class="col-md-4">
        <select name="heldTitleHow" required
          [ngClass]="{'is-invalid' : heldTitleHow && heldTitleHow.touched && heldTitleHow.invalid}"
          [(ngModel)]="borrower.declarations!.heldTitleHow" class="form-select form-select-solid" #heldTitleHow="ngModel"
          data-placeholder="Select One">
          <option></option>
          @for (heldTitleHow of heldTitleHows; track heldTitleHow.value) {
            <option [value]="heldTitleHow.value">
              {{heldTitleHow.name}}
            </option>
          }
        </select>
        <div class="invalid-feedback">{{ t('common.fieldRequiredSelectOne') }}</div>
      </div>
    </div>
  }
  <div class="row mb-5 rounded border p-4"
    [ngClass]="{'border-danger': haveRelationshipWithSeller.touched && haveRelationshipWithSeller.invalid}">
    <div class="col-lg-10 col-md-12 fv-row">
      <div class="position-relative">
        {{ t('wizard.declarations.haveRelationshipWithSeller') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" [value]="true" type="radio" name="haveRelationshipWithSeller" required
            id="bYesChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.haveRelationshipWithSeller"
            #haveRelationshipWithSeller="ngModel" />
          <label style="padding-right: 6px;" class="form-check-label" for="bYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" [value]="false" type="radio" name="haveRelationshipWithSeller" required
            id="bNoChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.haveRelationshipWithSeller"
            #haveRelationshipWithSeller="ngModel" />
          <label style="padding-right: 6px;" class="form-check-label" for="bNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': borrowedDownPayment.touched && borrowedDownPayment.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.borrowedDownPayment') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="borrowedDownPayment" id="cYesChecked{{borrower.borrowerId}}"
            required [(ngModel)]="borrower.declarations!.borrowedDownPayment" #borrowedDownPayment="ngModel"
            (change)="borrowedDownPaymentChange()" />
          <label style="padding-right: 6px;" class="form-check-label" for="cYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="borrowedDownPayment" id="cNoChecked{{borrower.borrowerId}}"
            required [(ngModel)]="borrower.declarations!.borrowedDownPayment" #borrowedDownPayment="ngModel"
            (change)="borrowedDownPaymentChange()" />
          <label style="padding-right: 6px;" class="form-check-label" for="cNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.borrowedDownPayment) {
      <div class="col-12 mt-4">
        <div class="row">
          <div class="col-md-8 fw-row">
            <div class="position-relative">
              {{ t('wizard.declarations.undisclosedMoneyAmountQuestion') }}
            </div>
          </div>
          <div class="col-md-4">
            <input type="text" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$" class="form-control form-control-solid"
              [(ngModel)]="borrower.declarations!.undisclosedMoneyAmount" required placeholder=""
              name="borrowedDownPaymentInfo"
              [ngClass]="{'is-invalid' : borrowedDownPaymentInfo && borrowedDownPaymentInfo.touched && borrowedDownPaymentInfo.invalid}"
              #borrowedDownPaymentInfo="ngModel" />
            <div class="invalid-feedback">{{ t('common.fieldRequiredEnterOne') }}</div>
          </div>
        </div>
      </div>
      @if (!isHidden('borrower.declarations.borrowedDownPayment.explanation')) {
        <div class="col-12 mt-4">
          <label class="form-label" for="borrowedDownPaymentExplanation{{borrower.borrowerId}}">
            {{ getLabel('borrower.declarations.borrowedDownPayment.explanation', t('wizard.declarations.explanationLabel')) }}
          </label>
          <textarea class="form-control form-control-solid" rows="3"
            [required]="isRequired('borrower.declarations.borrowedDownPayment.explanation')"
            id="borrowedDownPaymentExplanation{{borrower.borrowerId}}"
            name="borrowedDownPaymentExplanation{{borrower.borrowerId}}"
            #borrowedDownPaymentExplanation="ngModel"
            [(ngModel)]="getExplanation(ExplanationType.BorrowedDownPayment).description"
            [ngClass]="{'is-invalid': borrowedDownPaymentExplanation.touched && borrowedDownPaymentExplanation.invalid}"></textarea>
          <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
        </div>
      }
    }
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': applyingForOtherMortgage.touched && applyingForOtherMortgage.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.applyingForOtherMortgage') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" name="applyingForOtherMortgage" [value]="true" required
            id="d1YesChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.applyingForOtherMortgage"
            #applyingForOtherMortgage="ngModel" />
          <label style="padding-right: 6px;" class="form-check-label" for="d1YesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="applyingForOtherMortgage" required
            id="d1NoChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.applyingForOtherMortgage"
            #applyingForOtherMortgage="ngModel" />
          <label style="padding-right: 6px;" class="form-check-label" for="d1NoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': applyingForNonMortgageCredit.touched && applyingForNonMortgageCredit.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.applyingForNonMortgageCredit') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="applyingForNonMortgageCredit" required
            id="d2YesChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.applyingForNonMortgageCredit"
            #applyingForNonMortgageCredit="ngModel" />
          <label style="padding-right: 6px;" class="form-check-label" for="d2YesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="applyingForNonMortgageCredit" required
            id="d2NoChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.applyingForNonMortgageCredit"
            #applyingForNonMortgageCredit="ngModel" />
          <label style="padding-right: 6px;" class="form-check-label" for="d2NoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': propertyHasLienWithCleanEnergyProgram.touched && propertyHasLienWithCleanEnergyProgram.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.propertyHasLienWithCleanEnergyProgram') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="propertyHasLienWithCleanEnergyProgram"
            required id="eYesChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.propertyHasLienWithCleanEnergyProgram"
            #propertyHasLienWithCleanEnergyProgram="ngModel" />
          <label style="padding-right: 6px;" class="form-check-label" for="eYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="propertyHasLienWithCleanEnergyProgram"
            required id="eNoChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.propertyHasLienWithCleanEnergyProgram"
            #propertyHasLienWithCleanEnergyProgram="ngModel" />
          <label style="padding-right: 6px;" class="form-check-label" for="eNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="row rounded border mb-5 p-4" [ngClass]="{'border-danger': coSignedLoan.touched && coSignedLoan.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.coSignedLoan') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="coSignedLoan" id="fYesChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.coSignedLoan" #coSignedLoan="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.coSignedLoan, ExplanationType.CoMakerEndorserOnNote)" />
          <label style="padding-right: 6px;" class="form-check-label" for="fYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="coSignedLoan" id="fNoChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.coSignedLoan" #coSignedLoan="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.coSignedLoan, ExplanationType.CoMakerEndorserOnNote)" />
          <label style="padding-right: 6px;" class="form-check-label" for="fNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.coSignedLoan && !isHidden('borrower.declarations.coSignedLoan.explanation')) {
      <div class="col-12 mt-4">
        <label class="form-label" for="coSignedLoanExplanation{{borrower.borrowerId}}">
          {{ getLabel('borrower.declarations.coSignedLoan.explanation', t('wizard.declarations.explanationLabel')) }}
        </label>
        <textarea class="form-control form-control-solid" rows="3"
          [required]="isRequired('borrower.declarations.coSignedLoan.explanation')"
          id="coSignedLoanExplanation{{borrower.borrowerId}}"
          name="coSignedLoanExplanation{{borrower.borrowerId}}"
          #coSignedLoanExplanation="ngModel"
          [(ngModel)]="getExplanation(ExplanationType.CoMakerEndorserOnNote).description"
          [ngClass]="{'is-invalid': coSignedLoanExplanation.touched && coSignedLoanExplanation.invalid}"></textarea>
        <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
      </div>
    }
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': haveJudgement.touched && haveJudgement.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.haveJudgement') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="haveJudgement" id="gYesChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.haveJudgement" #haveJudgement="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveJudgement, ExplanationType.OutstandingJudgments)" />
          <label style="padding-right: 6px;" class="form-check-label" for="gYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="haveJudgement" id="gNoChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.haveJudgement" #haveJudgement="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveJudgement, ExplanationType.OutstandingJudgments)" />
          <label style="padding-right: 6px;" class="form-check-label" for="gNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.haveJudgement && !isHidden('borrower.declarations.haveJudgement.explanation')) {
      <div class="col-12 mt-4">
        <label class="form-label" for="haveJudgementExplanation{{borrower.borrowerId}}">
          {{ getLabel('borrower.declarations.haveJudgement.explanation', t('wizard.declarations.explanationLabel')) }}
        </label>
        <textarea class="form-control form-control-solid" rows="3"
          [required]="isRequired('borrower.declarations.haveJudgement.explanation')"
          id="haveJudgementExplanation{{borrower.borrowerId}}"
          name="haveJudgementExplanation{{borrower.borrowerId}}"
          #haveJudgementExplanation="ngModel"
          [(ngModel)]="getExplanation(ExplanationType.OutstandingJudgments).description"
          [ngClass]="{'is-invalid': haveJudgementExplanation.touched && haveJudgementExplanation.invalid}"></textarea>
        <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
      </div>
    }
  </div>
  <div class="row rounded border mb-5 p-4" [ngClass]="{'border-danger': haveTaxDebt.touched && haveTaxDebt.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.haveTaxDebt') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="haveTaxDebt" id="hYesChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.haveTaxDebt" #haveTaxDebt="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveTaxDebt, ExplanationType.DelinquencyOrDefault)" />
          <label style="padding-right: 6px;" class="form-check-label" for="hYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="haveTaxDebt" id="hNoChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.haveTaxDebt" #haveTaxDebt="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveTaxDebt, ExplanationType.DelinquencyOrDefault)" />
          <label style="padding-right: 6px;" class="form-check-label" for="hNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.haveTaxDebt && !isHidden('borrower.declarations.haveTaxDebt.explanation')) {
      <div class="col-12 mt-4">
        <label class="form-label" for="haveTaxDebtExplanation{{borrower.borrowerId}}">
          {{ getLabel('borrower.declarations.haveTaxDebt.explanation', t('wizard.declarations.explanationLabel')) }}
        </label>
        <textarea class="form-control form-control-solid" rows="3"
          [required]="isRequired('borrower.declarations.haveTaxDebt.explanation')"
          id="haveTaxDebtExplanation{{borrower.borrowerId}}"
          name="haveTaxDebtExplanation{{borrower.borrowerId}}"
          #haveTaxDebtExplanation="ngModel"
          [(ngModel)]="getExplanation(ExplanationType.DelinquencyOrDefault).description"
          [ngClass]="{'is-invalid': haveTaxDebtExplanation.touched && haveTaxDebtExplanation.invalid}"></textarea>
        <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
      </div>
    }
  </div>
  <div class="row rounded border mb-5 p-4" [ngClass]="{'border-danger': haveLawsuit.touched && haveLawsuit.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.haveLawsuit') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="haveLawsuit" id="iYesChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.haveLawsuit" #haveLawsuit="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveLawsuit, ExplanationType.PartyToLawsuit)" />
          <label style="padding-right: 6px;" class="form-check-label" for="iYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="haveLawsuit" id="iNoChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.haveLawsuit" #haveLawsuit="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveLawsuit, ExplanationType.PartyToLawsuit)" />
          <label style="padding-right: 6px;" class="form-check-label" for="iNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.haveLawsuit && !isHidden('borrower.declarations.haveLawsuit.explanation')) {
      <div class="col-12 mt-4">
        <label class="form-label" for="haveLawsuitExplanation{{borrower.borrowerId}}">
          {{ getLabel('borrower.declarations.haveLawsuit.explanation', t('wizard.declarations.explanationLabel')) }}
        </label>
        <textarea class="form-control form-control-solid" rows="3"
          [required]="isRequired('borrower.declarations.haveLawsuit.explanation')"
          id="haveLawsuitExplanation{{borrower.borrowerId}}"
          name="haveLawsuitExplanation{{borrower.borrowerId}}"
          #haveLawsuitExplanation="ngModel"
          [(ngModel)]="getExplanation(ExplanationType.PartyToLawsuit).description"
          [ngClass]="{'is-invalid': haveLawsuitExplanation.touched && haveLawsuitExplanation.invalid}"></textarea>
        <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
      </div>
    }
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': haveConveyedTitleInLieuOfForeclosure.touched && haveConveyedTitleInLieuOfForeclosure.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.haveConveyedTitleInLieuOfForeclosure') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="haveConveyedTitleInLieuOfForeclosure"
            required id="jYesChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.haveConveyedTitleInLieuOfForeclosure"
            #haveConveyedTitleInLieuOfForeclosure="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveConveyedTitleInLieuOfForeclosure, ExplanationType.ObligatedOnLoanForeclosedOrDeedInLieuOfJudgment)" />
          <label style="padding-right: 6px;" class="form-check-label" for="jYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="haveConveyedTitleInLieuOfForeclosure"
            required id="jNoChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.haveConveyedTitleInLieuOfForeclosure"
            #haveConveyedTitleInLieuOfForeclosure="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveConveyedTitleInLieuOfForeclosure, ExplanationType.ObligatedOnLoanForeclosedOrDeedInLieuOfJudgment)" />
          <label style="padding-right: 6px;" class="form-check-label" for="jNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.haveConveyedTitleInLieuOfForeclosure && !isHidden('borrower.declarations.haveConveyedTitleInLieuOfForeclosure.explanation')) {
      <div class="col-12 mt-4">
        <label class="form-label" for="haveConveyedTitleInLieuOfForeclosureExplanation{{borrower.borrowerId}}">
          {{ getLabel('borrower.declarations.haveConveyedTitleInLieuOfForeclosure.explanation', t('wizard.declarations.explanationLabel')) }}
        </label>
        <textarea class="form-control form-control-solid" rows="3"
          [required]="isRequired('borrower.declarations.haveConveyedTitleInLieuOfForeclosure.explanation')"
          id="haveConveyedTitleInLieuOfForeclosureExplanation{{borrower.borrowerId}}"
          name="haveConveyedTitleInLieuOfForeclosureExplanation{{borrower.borrowerId}}"
          #haveConveyedTitleInLieuOfForeclosureExplanation="ngModel"
          [(ngModel)]="getExplanation(ExplanationType.ObligatedOnLoanForeclosedOrDeedInLieuOfJudgment).description"
          [ngClass]="{'is-invalid': haveConveyedTitleInLieuOfForeclosureExplanation.touched && haveConveyedTitleInLieuOfForeclosureExplanation.invalid}"></textarea>
        <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
      </div>
    }
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': haveCompletedShortSale.touched && haveCompletedShortSale.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.haveCompletedShortSale') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="haveCompletedShortSale" required
            id="kYesChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.haveCompletedShortSale"
            #haveCompletedShortSale="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveCompletedShortSale, ExplanationType.Other)" />
          <label style="padding-right: 6px;" class="form-check-label" for="kYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="haveCompletedShortSale" required
            id="kNoChecked{{borrower.borrowerId}}" [(ngModel)]="borrower.declarations!.haveCompletedShortSale"
            #haveCompletedShortSale="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.haveCompletedShortSale, ExplanationType.Other)" />
          <label style="padding-right: 6px;" class="form-check-label" for="kNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.haveCompletedShortSale && !isHidden('borrower.declarations.haveCompletedShortSale.explanation')) {
      <div class="col-12 mt-4">
        <label class="form-label" for="haveCompletedShortSaleExplanation{{borrower.borrowerId}}">
          {{ getLabel('borrower.declarations.haveCompletedShortSale.explanation', t('wizard.declarations.explanationLabel')) }}
        </label>
        <textarea class="form-control form-control-solid" rows="3"
          [required]="isRequired('borrower.declarations.haveCompletedShortSale.explanation')"
          id="haveCompletedShortSaleExplanation{{borrower.borrowerId}}"
          name="haveCompletedShortSaleExplanation{{borrower.borrowerId}}"
          #haveCompletedShortSaleExplanation="ngModel"
          [(ngModel)]="getExplanation(ExplanationType.Other).description"
          [ngClass]="{'is-invalid': haveCompletedShortSaleExplanation.touched && haveCompletedShortSaleExplanation.invalid}"></textarea>
        <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
      </div>
    }
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': beenForclosed.touched && beenForclosed.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.beenForeclosed') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="beenForclosed" id="lYesChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.beenForclosed" #beenForclosed="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.beenForclosed, ExplanationType.DirectIndirectForeclosedPropertyPastSevenYears)" />
          <label style="padding-right: 6px;" class="form-check-label" for="lYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="beenForclosed" id="lNoChecked{{borrower.borrowerId}}" required
            [(ngModel)]="borrower.declarations!.beenForclosed" #beenForclosed="ngModel"
            (change)="onDeclarationYesNoChange(borrower.declarations!.beenForclosed, ExplanationType.DirectIndirectForeclosedPropertyPastSevenYears)" />
          <label style="padding-right: 6px;" class="form-check-label" for="lNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.beenForclosed && !isHidden('borrower.declarations.beenForclosed.explanation')) {
      <div class="col-12 mt-4">
        <label class="form-label" for="beenForclosedExplanation{{borrower.borrowerId}}">
          {{ getLabel('borrower.declarations.beenForclosed.explanation', t('wizard.declarations.explanationLabel')) }}
        </label>
        <textarea class="form-control form-control-solid" rows="3"
          [required]="isRequired('borrower.declarations.beenForclosed.explanation')"
          id="beenForclosedExplanation{{borrower.borrowerId}}"
          name="beenForclosedExplanation{{borrower.borrowerId}}"
          #beenForclosedExplanation="ngModel"
          [(ngModel)]="getExplanation(ExplanationType.DirectIndirectForeclosedPropertyPastSevenYears).description"
          [ngClass]="{'is-invalid': beenForclosedExplanation.touched && beenForclosedExplanation.invalid}"></textarea>
        <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
      </div>
    }
  </div>
  <div class="row rounded border mb-5 p-4"
    [ngClass]="{'border-danger': declaredBankruptcy.touched && declaredBankruptcy.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative">
        {{ t('wizard.declarations.declaredBankruptcy') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" [value]="true" name="declaredBankruptcy" id="mYesChecked{{borrower.borrowerId}}"
            required [(ngModel)]="borrower.declarations!.declaredBankruptcy" #declaredBankruptcy="ngModel"
            (change)="declaredBankruptcyChange()" />
          <label style="padding-right: 6px;" class="form-check-label" for="mYesChecked{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" type="radio" [value]="false" name="declaredBankruptcy" id="mNoChecked{{borrower.borrowerId}}"
            required [(ngModel)]="borrower.declarations!.declaredBankruptcy" #declaredBankruptcy="ngModel"
            (change)="declaredBankruptcyChange()" />
          <label style="padding-right: 6px;" class="form-check-label" for="mNoChecked{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
    @if (borrower.declarations!.declaredBankruptcy) {
      <div class="col-12 mt-4">
        <div class="row">
          <div class="col-md-8 fw-row">
            <div class="position-relative">
              {{ t('wizard.declarations.bankruptcyTypeQuestion') }}
            </div>
          </div>
          <div class="col-md-4">
            <select name="bankruptcyType" required
              [ngClass]="{'is-invalid' : bankruptcyType && bankruptcyType.touched && bankruptcyType.invalid}"
              [(ngModel)]="borrower.declarations!.bankruptcyType" class="form-select form-select-solid"
              #bankruptcyType="ngModel" data-placeholder="Select One">
              <option></option>
              @for (bankruptcyType of bankruptcyTypes; track bankruptcyType.value) {
                <option [value]="bankruptcyType.value">
                  {{bankruptcyType.name}}
                </option>
              }
            </select>
            <div class="invalid-feedback">{{ t('common.fieldRequiredSelectOne') }}</div>
          </div>
        </div>
      </div>
      @if (!isHidden('borrower.declarations.declaredBankruptcy.explanation')) {
        <div class="col-12 mt-4">
          <label class="form-label" for="declaredBankruptcyExplanation{{borrower.borrowerId}}">
            {{ getLabel('borrower.declarations.declaredBankruptcy.explanation', t('wizard.declarations.explanationLabel')) }}
          </label>
          <textarea class="form-control form-control-solid" rows="3"
            [required]="isRequired('borrower.declarations.declaredBankruptcy.explanation')"
            id="declaredBankruptcyExplanation{{borrower.borrowerId}}"
            name="declaredBankruptcyExplanation{{borrower.borrowerId}}"
            #declaredBankruptcyExplanation="ngModel"
            [(ngModel)]="getExplanation(ExplanationType.DeclaredBankruptcyPastSevenYears).description"
            [ngClass]="{'is-invalid': declaredBankruptcyExplanation.touched && declaredBankruptcyExplanation.invalid}"></textarea>
          <div class="invalid-feedback">{{ t('wizard.declarations.explanationRequired') }}</div>
        </div>
      }
    }
  </div>
</form>
</ng-container>
